import styled from "styled-components";
import {
	COLOR_TEXT_PRIMARY_B2U,
	FONT_WT_HEAVY,
} from "@website-builder/utilities-index";

export const PaginationWrapper = styled.ul`
	list-style: none;
	display: flex;
	justify-content: center;
	color: ${COLOR_TEXT_PRIMARY_B2U};
`;

export const PageItem = styled.li`
	margin: 5px;
	a {
		text-decoration: none;
		color: ${COLOR_TEXT_PRIMARY_B2U};
	}
	&.bold {
		font-weight: ${FONT_WT_HEAVY};
	}
	&.active {
		a {
			font-weight: ${FONT_WT_HEAVY};
		}
	}
`;
